import { Box, Typography } from "@mui/material";

export function FormSection(props: { children: React.ReactNode; label: string; }) {
    return <Box sx={{ border: "1px dashed #ccc", p: 3, mt: 3 }}>
        <Typography fontSize={15} sx={{ marginTop: "-24px", bgcolor: "white", float: "left", px: "5px" }}>{props.label}</Typography>
        {props.children}
    </Box>;
}
